import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=20d7e3d3"
import script from "./Organizations.ts?vue&type=script&lang=ts&external"
export * from "./Organizations.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports